
const API_URLS = {
  // baseUrl: '',
  // openQuizEvent: 'https://eu2-stagingref.api.vodafone.com/payments/v1/payment/auth/customerInteractionAPI/v2/customerInteraction',
  // getQuizLevels: 'https://eu2-stagingref.api.vodafone.com/payments/v1/payment/auth/productOfferingAPI/v2/productOffering',

  //test
  baseUrl: '',
  openQuizEvent: 'https://api-mobile-ci-vfal.vodafone.com/auth/customerInteractionAPI/v2/customerInteraction',
  getQuizLevels: 'https://api-mobile-ci-vfal.vodafone.com/auth/productOfferingAPI/v2/productOffering',
  getRewards: 'https://api-mobile-ci-vfal.vodafone.com/auth/salesOrderAPI/v2.1/salesOrder',
}


export { API_URLS }
